if(window.location.href.includes('/collections/')){
  // Save scroll position before navigating away
  window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('scrollPosition', window.scrollY);
  });

  document.addEventListener('DOMContentLoaded', () => {
      const scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
          window.scrollTo(0, parseInt(scrollPosition, 10));
          sessionStorage.removeItem('scrollPosition'); // Clear after use
      }
  });

}

function updatecart(url){
  fetch(url).then(function (response) {
      // The API call was successful!
      return response.text();
  }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      document.querySelector('.cart__footer .totals__subtotal-value').innerHTML =  doc.querySelector(".cart__footer .totals__subtotal-value").innerHTML;
      

  }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
  });
}

document.querySelectorAll(".hasmenu~ul .active").forEach(function(link){
  link.parentElement.classList.remove("hidden");
});

function updatelinkdata(url){
  fetch(url).then(function (response) {
      // The API call was successful!
      return response.text();
  }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      document.querySelector('#MainContent').innerHTML =  doc.querySelector("#MainContent").innerHTML;
  }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
  });
}

document.querySelector(".icon-hamburger").addEventListener("click", function(){
    this.classList.add("hidden");
    document.querySelector(".header-icons-container .icon-close").classList.remove("hidden");
    document.querySelector(".header-new-container .header-menus").style.display = 'block';
    document.querySelector("#MainContent").classList.add("hidden");
});

document.querySelector(".header-icons-container .icon-close").addEventListener("click", function(){
    this.classList.add("hidden");
    document.querySelector(".header-icons-container .icon-hamburger").classList.remove("hidden");
    document.querySelector(".header-new-container .header-menus").style.display = 'none';
    document.querySelector("#MainContent").classList.remove("hidden");
});

document.querySelectorAll(".hasmenu").forEach(function(menu){
    menu.addEventListener("click", function(){
      if (document.querySelector(".header-menus ul li ul li.active") != null) {
        document.querySelector(".header-menus ul li ul li.active").classList.remove("active");  
      }
      
      document.querySelectorAll(".hasmenu").forEach(function(menunew){
        menunew.nextSibling.classList.add("hidden");
      });
      this.nextSibling.classList.toggle("hidden");
    })
});

document.querySelectorAll(".product-images .left-container img").forEach(function(img){
  img.addEventListener("click", function(){
    document.querySelectorAll(".product-images .left-container img").forEach(function(img2){
        img2.classList.remove("active");
    });
    img.classList.add("active");
  })  
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

document.querySelectorAll(".linkhover a").forEach(function(link){
  link.addEventListener("mouseover", function(){
    var url = this.getAttribute("href");
    updatelinkdata(url);
  });
});

function ontimeupdatecart(){
  setTimeout(() => {
    updatecart("/cart/update");
  }, 500);
}